
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { PlanRequest } from "../../domain/requests/plans/plan.request";
import { Plan } from "../../domain";
import { PlansRepository } from "../../repositories";
import { PlanWithLocationRequest } from "../../domain/requests/plans/plan-with-locations.request";

@Injectable({ providedIn: 'root' })
export class AddPlanWithLocationUsecase implements UseCase<PlanWithLocationRequest, string> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: PlanWithLocationRequest): Observable<string> {
    return this.planRepository.addPlanWithLocation(params);
  }

}
